var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-background",attrs:{"data-image":"https://cdn.sankex.uk/img/test.jpg"}},[_c('div',{staticClass:"container"},[_c('RaceDetail')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }